import React from "react";
import {
  Button,
  Col,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Table,
} from "reactstrap";
import { imageBaseApi } from "../../../utilis/imageHelper";
import { Download } from "lucide-react";

const FranchiseDetail = ({ isOpen, toggle, selectedItem }) => {
  const renderItem = (label, value) => (
    <div className="mb-3">
      <div className="text-muted small">{label}</div>
      <div className="fw-semibold">
        {value || <span className="text-muted">N/A</span>}
      </div>
    </div>
  );

  return (
    <Offcanvas isOpen={isOpen} toggle={toggle} direction="end">
      <OffcanvasHeader toggle={toggle}>
        Franchise Enquiry Detail
      </OffcanvasHeader>

      <OffcanvasBody>
        <div className="p-2">
          {/* Section: Basic Info */}
          <h6 className="mb-3 text-primary">Basic Information</h6>
          {renderItem("Full Name", selectedItem?.fullName)}
          {renderItem("Email", selectedItem?.email)}
          {renderItem(
            "Phone",
            selectedItem
              ? `${selectedItem.phoneCountryCode || "+977"} ${
                  selectedItem.phone
                }`
              : null,
          )}

          <hr />

          <h6 className="mb-3 text-primary">Application Info</h6>
          {renderItem("Preferred Location", selectedItem?.prefreredLocation)}
          {renderItem("Message", selectedItem?.message)}

          <hr />

          <h6 className="mb-3 text-primary">Submitted At</h6>
          {renderItem(
            "Date",
            selectedItem?.createdAt
              ? new Date(selectedItem.createdAt).toLocaleString()
              : null,
          )}
          <hr />

          {/* Section: Attachment */}
          <h6 className="mb-3 text-primary">Attachment</h6>
          {selectedItem?.attachmentUrl ? (
            <Button
              color="primary"
              tag="a"
              href={`${imageBaseApi}${selectedItem?.attachmentUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              className="d-inline-flex align-items-center"
            >
              <Download size={16} className="me-2" />
              Download Resume
            </Button>
          ) : (
            <div className="text-muted">No resume uploaded</div>
          )}
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
};
export default FranchiseDetail;
